import React from "react";
import { Link, useHistory } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import useDrawerStyles from "./drawerList.styles";

const AccordionMenuComponent = ({
	feature,
	handleClick,
	isOpen,
	handleDrawerOpen,
}) => {
	const classes = useDrawerStyles();
	const history = useHistory();
	const onClickMenu = () => {
		if (!feature.disabled) {
			if (feature.sub) {
				return handleClick(feature.name);
			}
			handleDrawerOpen();
			history.push(feature.url);
		}
	};
	return (
		<>
			<ListItem button disabled={feature.disabled} onClick={onClickMenu}>
				<ListItemIcon>{feature.icon}</ListItemIcon>
				<ListItemText>{feature.name}</ListItemText>
				{feature.sub ? (
					isOpen === feature.name ? (
						<ExpandLess />
					) : (
						<ExpandMore />
					)
				) : null}
			</ListItem>
			{feature.sub && (
				<Collapse
					in={isOpen === feature.name}
					timeout="auto"
					unmountOnExit
				>
					<List component="div" disablePadding dense={true}>
						{feature.sub
							.sort((a: any, b: any) => {
								//arrange
								if (a.name < b.name) return -1;
								if (a.name > b.name) return 1;
								return 0;
							})
							.map((sub, key) => (
								<ListItem
									key={key}
									button
									disabled={sub.disabled}
									className={classes.nested}
									onClick={() => handleDrawerOpen()}
									component={Link}
									to={sub.url}
								>
									<ListItemIcon>{sub.icon}</ListItemIcon>
									<ListItemText>{sub.name}</ListItemText>
								</ListItem>
							))}
					</List>
				</Collapse>
			)}
		</>
	);
};

export default AccordionMenuComponent;
